import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const roleService = {
  get_list_roles: (token, params = {}) => {
    const uri = API_ROUTES.ROLE.GET_LIST;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
